import React from "react";
import fondoDownload from "../../assets/image/stella/fondodownload.jpg";
import logoDownload from "../../assets/image/stella/downloadfoto.png";
import fondoFlujo from "../../assets/image/stella/fondo-web.png";
import {HashLink} from "react-router-hash-link";


function Section1() {

    return (
        <section className="relative pt-[220px] pb-30 overflow-hidden" id="inicio">
            <div
                className="absolute inset-0 bg-no-repeat bg-cover bg-center z-0"
                style={{
                    backgroundImage: `linear-gradient(70deg, rgb(0, 0, 0), rgba(20, 20, 20, 0.24)), url(${fondoDownload})`,
                }}
            ></div>

            <div
                className="relative z-10 container max-w-[1000px] px-5 md:px-12 flex flex-col justify-center items-center text-center pb-40">
                <img alt="apk Stella TV" width="300" height="300" decoding="async" data-nimg="1"
                     className="w-[160px] h-auto drop-shadow-[0_12px_45px_rgba(255,149,1,0.35)]"
                     src={logoDownload}/><h1
                className="mt-3 text-[32px] leading-tight md:text-[45px] font-bold uppercase">Descargar Stella TV
                Apk</h1><p className="mt-3 leading-relaxed text-white">Abajo tienes los links directos para
                <HashLink to="/descarga/#inicio" className="hover:text-primary font-semibold">
                    descargar Stella TV apk
                </HashLink>
                en celulares, smart tv, fire tv stick, tv box y pc windows o laptop mac OS. <strong>Stella TV
                    25.11.8</strong> Aprovecha las promociones al
                <HashLink to="/#inicio" className="text-active font-semibold">
                    comprar
                    Stella TV oficial</HashLink>
                2025.</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"
                 className="absolute bottom-0 left-0 w-full h-[54px] rotate-180">
                <path opacity="0.33"
                      d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"></path>
                <path opacity="0.66"
                      d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"></path>
                <path
                    d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"></path>
            </svg>
        </section>
    );
}

export default Section1;
